module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leveler",
    class: {
      leveler_error: _vm.error
    }
  }, [_c('button', {
    staticClass: "leveler__btn leveler__btn_minus",
    class: {
      leveler__btn_minus_error: _vm.error
    },
    on: {
      "click": function($event) {
        return _vm.setLevel(0)
      }
    }
  }), _c('span', [_vm._v("Оценка " + _vm._s(_vm.levelValue))]), _c('button', {
    staticClass: "leveler__btn leveler__btn_plus",
    class: {
      leveler__btn_plus_error: _vm.error
    },
    on: {
      "click": function($event) {
        return _vm.setLevel(1)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a57b55b2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formrange/components/Leveler.vue
// module id = 99df5de7a1637dd4e47d
// module chunks = 6